import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const ProgressBar = ({ completed, total, containerStyle = {}, style = {} }) => {
    let clampedCompleted = completed > total ? total : completed;
    const percentage = Number.parseFloat(clampedCompleted / total * 100).toFixed(2);

    return (
        <div className={ classnames('progress-bar', { 'progress-bar--completed': completed > total }) } style={containerStyle}>
            <div
                className="progress-bar__line"
                style={ { width: `${percentage}%`, ...style } } />
        </div>
    );
};

ProgressBar.propTypes = {
    completed: PropTypes.number,
    total: PropTypes.number,
    containerStyle: PropTypes.object,
    style: PropTypes.object
};

ProgressBar.defaultProps = {
    completed: 0,
    total: 1,
    containerStyle: {},
    style: {}
};

export default ProgressBar;
